/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusHistoryPageVo } from './BonusHistoryPageVo';
import {
    BonusHistoryPageVoFromJSON,
    BonusHistoryPageVoFromJSONTyped,
    BonusHistoryPageVoToJSON,
    BonusHistoryPageVoToJSONTyped,
} from './BonusHistoryPageVo';

/**
 * 
 * @export
 * @interface ResponseBonusHistoryPageVo
 */
export interface ResponseBonusHistoryPageVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBonusHistoryPageVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBonusHistoryPageVo
     */
    message?: string;
    /**
     * 
     * @type {BonusHistoryPageVo}
     * @memberof ResponseBonusHistoryPageVo
     */
    data?: BonusHistoryPageVo;
}

/**
 * Check if a given object implements the ResponseBonusHistoryPageVo interface.
 */
export function instanceOfResponseBonusHistoryPageVo(value: object): value is ResponseBonusHistoryPageVo {
    return true;
}

export function ResponseBonusHistoryPageVoFromJSON(json: any): ResponseBonusHistoryPageVo {
    return ResponseBonusHistoryPageVoFromJSONTyped(json, false);
}

export function ResponseBonusHistoryPageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBonusHistoryPageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BonusHistoryPageVoFromJSON(json['data']),
    };
}

export function ResponseBonusHistoryPageVoToJSON(json: any): ResponseBonusHistoryPageVo {
    return ResponseBonusHistoryPageVoToJSONTyped(json, false);
}

export function ResponseBonusHistoryPageVoToJSONTyped(value?: ResponseBonusHistoryPageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BonusHistoryPageVoToJSON(value['data']),
    };
}

